/* eslint-disable jsx-a11y/anchor-is-valid */
import BoletosOnline from 'components/molecules/boletos_online';
import MyAccountCompanyData from 'components/molecules/my_account_company_data';
import MyAccountSolicitation from 'components/molecules/my_account_solicitation';
import MyFilters from 'components/molecules/my_filters';
import MySignature from 'components/molecules/my_signature';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MyAccountState, MyAccountTypes } from 'store/modules/my_account_store/types';
import UserCenter from 'components/organisms/user_center';
import { getMyTokens } from 'services/conlicitacao_api_request';
import { Container } from './styles';

const MyAccount = () => {
  const dispatch = useDispatch();
  const queryString = window.location.pathname;
  const [hasApiToken, setHasApiToken] = useState<boolean>(false);

  const { my_account } = useSelector<ApplicationState, MyAccountState>(
    (state) => state.session.my_account,
  );
  useEffect(() => {
    document.title = 'Minha conta - ConLicitação';

    getMyTokens()
      .then((data) => setHasApiToken(Boolean(data.api_token)))
      .catch(() => setHasApiToken(false));
  }, []);

  if (queryString === '/boletim_web/minha_conta/boletos_online_new') {
    dispatch({ type: MyAccountTypes.VIEW_COMPONENT, view: 'boletos_online' });
  }
  return (
    <Container>
      <div className="page-container">
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-md-3">
              <div className="list-group">
                <h5 className="list-group-item mb-0 font-weight-bold pt-3">Minha conta</h5>
                <a
                  href="/minha_conta/usuario"
                  className={`list-group-item list-group-item-action ${
                    my_account?.viewComponent === 'usuario' && 'active'
                  }`}
                  onClick={() => dispatch({ type: MyAccountTypes.VIEW_COMPONENT, view: 'usuario' })}
                >
                  Usuários
                </a>
                <a
                  href="/minha_conta/filtros"
                  className={`list-group-item list-group-item-action ${
                    my_account?.viewComponent === 'filtros' && 'active'
                  }`}
                  onClick={() => dispatch({ type: MyAccountTypes.VIEW_COMPONENT, view: 'filtros' })}
                >
                  Meus Filtros
                </a>
                <a
                  href="/minha_conta/dados_empresa"
                  className={`list-group-item list-group-item-action ${
                    my_account?.viewComponent === 'dados_empresa' && 'active'
                  }`}
                  onClick={() =>
                    dispatch({ type: MyAccountTypes.VIEW_COMPONENT, view: 'dados_empresa' })
                  }
                >
                  Dados da Empresa
                </a>
                <a
                  href="/minha_conta/solicitacoes"
                  className={`list-group-item list-group-item-action ${
                    my_account?.viewComponent === 'solicitation' && 'active'
                  }`}
                  onClick={() =>
                    dispatch({ type: MyAccountTypes.VIEW_COMPONENT, view: 'solicitation' })
                  }
                >
                  Solicitações
                </a>
                {hasApiToken && (
                  <a
                    href="/conlicitacao_api/meus_tokens"
                    className="list-group-item list-group-item-action"
                  >
                    Meu token da API
                  </a>
                )}
              </div>
              <div className="list-group mt-3 mb-3">
                <h5 className="list-group-item mb-0 font-weight-bold pt-3">Dados da assinatura</h5>
                <a
                  href="/minha_conta/minha_assinatura"
                  className={`list-group-item list-group-item-action ${
                    my_account?.viewComponent === 'mysubscription' && 'active'
                  }`}
                  onClick={() =>
                    dispatch({ type: MyAccountTypes.VIEW_COMPONENT, view: 'mysubscription' })
                  }
                >
                  Minha Assinatura
                </a>
                <a
                  href="/planos"
                  className={`list-group-item list-group-item-action ${
                    my_account?.viewComponent === 'plansprice' && 'active'
                  }`}
                >
                  Planos e Preços
                </a>
                <a
                  href="/minha_conta/boletos_online"
                  className={`list-group-item list-group-item-action ${
                    my_account?.viewComponent === 'boletos_online' && 'active'
                  }`}
                  onClick={() =>
                    dispatch({ type: MyAccountTypes.VIEW_COMPONENT, view: 'boletos_online' })
                  }
                >
                  Boletos Online
                </a>
              </div>
            </div>
            <div className="col-md-9 p-0">
              {my_account?.viewComponent === 'usuario' && <UserCenter />}
              {my_account?.viewComponent === 'dados_empresa' && <MyAccountCompanyData />}
              {my_account?.viewComponent === 'mysubscription' && <MySignature />}
              {my_account?.viewComponent === 'solicitation' && <MyAccountSolicitation />}
              {my_account?.viewComponent === 'filtros' && <MyFilters />}
              {my_account?.viewComponent === 'boletos_online' && <BoletosOnline />}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default MyAccount;
